import { toNumber, uniqBy } from 'lodash'

const reduceAttractions = (attractions = []) =>
  attractions.map(attraction => {
    const resources = uniqBy(attraction.resources || [], 'id')
    const prices = resources
      ?.map(resource => {
        // web price = Z. gate price = Z9.
        const webPrice = resource?.prices?.find(
          price => price?.priceList === 'Z',
        )
        return webPrice?.value
      })
      ?.filter(total => !!total)

    const priceFrom = prices?.length ? Math.min(...prices) : undefined
    const hasCapacity = resources?.some(resource => +resource.capacity)

    const coordinates = attraction?.directions?.destination
      ?.replace(/\s/g, '')
      ?.split(',')

    return {
      ...attraction,
      latitude: coordinates?.[0] ? toNumber(coordinates?.[0]) : null,
      longitude: coordinates?.[1] ? toNumber(coordinates?.[1]) : null,
      resources,
      priceFrom,
      hasCapacity,
      searchTerms: [
        attraction?.name || '',
        attraction?.description || '',
        attraction?.location || '',
        ...(attraction?.amenities?.map(amenity => amenity.name) || []),
        ...(attraction?.targetGroups || []),
      ]?.filter(term => !!term),
    }
  })

export default reduceAttractions
